export const NOTIFICATIONS_ROUTES = {
    GET_NOTIFICATIONS: "notifications",
    ADD_NOTIFICATION: "notifications/add",
    MARK_AS_VIEWED: "notifications/mark-as-viewed",
  };
  